import { render } from "./MenuDropdown.vue?vue&type=template&id=c3077732&ts=true"
import script from "./MenuDropdown.vue?vue&type=script&lang=ts"
export * from "./MenuDropdown.vue?vue&type=script&lang=ts"

import "./MenuDropdown.vue?vue&type=style&index=0&id=c3077732&lang=css"

import exportComponent from "/Users/camp/Desktop/code-time/acampa-gestao-pra/vuecode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__